// ABOUTME: Route for /machine/$equipmentId. Renders nothing — ChatLayout handles display.
// ABOUTME: ChatContainer reads the equipmentId via useParams and renders MachineDetailPage.

import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/_chat/machine/$equipmentId",
)({
  component: () => null,
});
